var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBox = function SvgCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.355 2 2 3.355 2 5v14c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3v-8h-2v8c0 .555-.445 1-1 1H5c-.555 0-1-.445-1-1V5c0-.555.445-1 1-1h9V2zm15.473 1.914-9.293 9.852-3.672-3.672-1.414 1.414 5.127 5.127L21.928 5.287z"
  })));
};
export default SvgCheckBox;